<template>
  <div>
    <person :model="schema.data.student" :has-address="false">
      <div slot="top" class="row form-group">
        <div class="col-12">
          <w-radio-list :model="schema.data.student.gender" :values="studentGenders" />
        </div>
      </div>

      <div class="row form-group">
        <div class="col-md-4">
          <w-select :model="schema.data.student.gradeLevel" :values="gradeLevels" />
        </div>

        <div class="col-md-4">
          <w-select :model="schema.data.student.behaviorGrade" :values="behaviorGrades" />
        </div>

        <div class="col-md-4">
          <w-input placeholder="0,00" :model="schema.data.student.averageGradePerLastSemester" />
        </div>
      </div>
    </person>

    <div ref="contests">
      <contest
        v-for="(contest, index) in schema.data.contests.$items"
        :key="'contest_' + index"
        :contest="contest.$item"
        :schema="schema"
        :index="index"
      >
        <template v-slot:contest="{ contest }">
          <slot name="contest" :contest="contest" />
        </template>
      </contest>
    </div>

    <panel>
      <div class="row">
        <div class="col-md-10">
          <w-vue-select
            label-field="name"
            placeholder="Wpisz nazwę konkursu"
            value-field="name"
            :model="$schema"
            :values="contests"
            :ajax="true"
            :taggable="true"
            @search="findContests"
          />
        </div>

        <div class="col-md-2">
          <w-button
            class="btn-primary w-100"
            text="Dodaj konkurs"
            icon="fas fa-plus"
            :disabled="!$schema.name.$model"
            @click="addContest"
          />
        </div>

        <div class="col-12">
          <w-error class="pt-2" :model="schema.data.contests" />
        </div>
      </div>
    </panel>

    <slot name="after" />

    <panel :title="schema.data.bankAccountOwner.$schema.title">
      <div class="row form-group">
        <div class="col-12">
          <yes-or-no :model="schema.data.student.isBankAccountOwner" />
        </div>
      </div>

      <person
        :model="schema.data.bankAccountOwner"
        :disabled="{
          firstName: schema.$model.data.student.isBankAccountOwner,
          lastName: schema.$model.data.student.isBankAccountOwner,
          gender: schema.$model.data.student.isBankAccountOwner
        }"
        :hide-error="{
          firstName: schema.$model.data.student.isBankAccountOwner,
          lastName: schema.$model.data.student.isBankAccountOwner,
          gender: schema.$model.data.student.isBankAccountOwner
        }"
      >
        <div class="row form-group">
          <div class="col-12">
            <w-input :model="schema.data.bankAccountOwner.pesel" />
          </div>
        </div>

        <div class="row form-group">
          <div class="col-12">
            <w-input :model="schema.data.bankAccountOwner.bankAccountNumber" />

            <p>{{ schema.data.bankAccountOwner.bankAccountNumber.$schema.description }}</p>
          </div>
        </div>
      </person>
    </panel>
  </div>
</template>

<script>
import WButton from '@/components/button/Button';
import Panel from '@/components/panel/Panel';
import { ContestType } from '@/enums/contestType.enum';
import { Errors } from '@/enums/errors.enum';
import { SchoolLevel } from '@/enums/schoolLevel.enum';
import { ow003PrezydenckiMixin } from '@/mixins/document/ow003Prezydencki';
import { formMixin } from '@/mixins/form';
import { methodsMixin } from '@/mixins/methods';
import { notificationsMixin } from '@/mixins/notifications';
import { replacePlaceholdersMixin } from '@/mixins/replacePlaceholders';
import schema from '@/schemas/contestPicker.schema';
import Contest from './Contest.vue';
import Person from './Person';
import YesOrNo from './YesOrNoRadio';

export default {
  components: { Contest, Person, Panel, WButton, YesOrNo },
  mixins: [formMixin, notificationsMixin, ow003PrezydenckiMixin, replacePlaceholdersMixin, methodsMixin],
  schema,
  props: {
    // schema dokumentu
    schema: { type: Object, required: true }
  },
  data() {
    return { model: {}, contests: [] };
  },
  methods: {
    // @vuese
    // Dodaje konkurs
    addContest() {
      if (this.$schema.name) {
        this.schema.data.contests.$addRow({
          contestId: this.$schema.id.$model,
          contestName: this.$schema.name.$model,
          contestNameMsc: this.$schema.declination.miejscownik.$model,
          contestNameDop: this.$schema.declination.dopelniacz.$model
        });
        this.$schema.$setData({ name: null, id: null, declination: { miejscownik: null, dopelniacz: null } });
        this.contests = [];

        this.setFocusOnLastChildInput('contests');
      }
    },
    // @vuese
    // Wyszukuje konkursy
    findContests(contestName) {
      const type = ContestType[this.schema.data.contestType.$model];
      const level = SchoolLevel[this.schema.data.school.level.$model];
      if (!type) {
        return this.notifyError(Errors.CONTEST_TYPE_NOT_SELECTED);
      }
      if (!level) {
        return this.notifyError(Errors.CONTEST_LEVEL_NOT_SELECTED);
      }
      this.$store
        .dispatch('contest/list', { search: contestName, type, level })
        .then(contests => (this.contests = contests.list))
        .catch(err => this.notifyError(Errors.CONTEST_CANNOT_LIST));
    }
  }
};
</script>
